import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataQualityIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DataQuality",
    children: /*#__PURE__*/_jsx("path", {
      d: "m18.25 6.26-.61.36c-.2.14-.38.31-.52.52l-.37.6c-.05.07-.16.07-.2 0l-.39-.63c-.1-.15-.24-.28-.38-.38l-.7-.46a.13.13 0 0 1 0-.21l.53-.27c.24-.15.44-.34.59-.58l.36-.64c.05-.07.16-.08.21 0l.39.66c.1.15.24.28.39.39l.69.43c.07.05.07.16 0 .21Zm4.42 2.2-.8.47c-.26.18-.5.41-.67.68l-.48.8c-.06.1-.2.1-.27 0l-.52-.83c-.14-.19-.31-.37-.51-.51l-.93-.61a.163.163 0 0 1 0-.27l.7-.36c.31-.19.57-.45.77-.75l.47-.84c.06-.1.21-.1.27 0l.52.88c.14.2.31.38.52.52l.91.56c.1.06.1.21 0 .27v-.02Zm-1.85-5.21-.44.26c-.14.1-.27.23-.37.37l-.26.44c-.03.05-.11.05-.15 0l-.28-.45c-.08-.1-.17-.2-.28-.28l-.5-.33c-.05-.03-.05-.11 0-.15l.38-.19c.17-.1.31-.24.42-.41l.25-.45c.03-.05.11-.05.15 0l.28.48c.08.1.17.2.28.28l.49.31c.05.03.05.11 0 .15h.02Zm8 14.36-5.36-2.72c-.31-.16-.69-.15-1 .03l-3.78 2.24c2.03 1.32 3.01 3.44 2.18 4.86-.87 1.5-3.39 1.65-5.63.35a6.15 6.15 0 0 1-2.09-1.94l-6.33 3.74c-.31.18-.51.52-.51.89v.97c0 .37.19.71.52.9l5.01 2.92c.32.19.73.18 1.05 0l16.01-9.48c.31-.18.51-.52.51-.89v-.94c0-.39-.22-.75-.57-.93ZM8.3 8.7c.24-.14.47-.23.68-.29L7.39 6.36S7.01 4.8 6.17 3.4c-.4-.66-1.54-2.06-2.9-1.02-.93.7-1.01 2.66.52 3.8C4.9 7 5.9 7.46 5.9 7.46l.97 1.17.68.89c.15-.31.38-.62.74-.83Zm11.2 12.53c-.58 1-2.26 1.1-3.74.24-1.46-.86-2.2-2.33-1.67-3.32l-5.68-7.48v-.03s.03-.72.45-.96c.48-.28.83-.21.84-.21h.1l6.09 7.82c.61.02 1.3.21 1.95.59 1.49.87 2.23 2.37 1.65 3.36Z"
    })
  }));
};